"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortTopologically = void 0;
const remeda_1 = require("remeda");
const createDependencyGraph = (dependencyList) => (0, remeda_1.pipe)(dependencyList, (0, remeda_1.reduce)((graph, [node, dependency]) => {
    if (!graph[node]) {
        // eslint-disable-next-line no-param-reassign
        graph[node] = [];
    }
    // let's also init the depends on node, such that our graph isn't sparsely populated
    if (!graph[dependency]) {
        // eslint-disable-next-line no-param-reassign
        graph[dependency] = [];
    }
    graph[node].push(dependency);
    return graph;
}, {}));
/**
 * Accepts a list of dependency tuples in the form of [OutputNode, InputNode],
 * in which the OutputNode has a dependency on the child,
 * and returns one of the possible topologically sorted solutions.
 *
 * If a cycle is detected, the sortedList will be undefined, and the cycles member
 * will be populated with all nodes identified in the cycle(s)
 *
 * There are several algo's for topological sort.  Implemented below is
 * is a dfs utilizing "visitingNodes" and "visitedNodes" pattern for
 * cycle detection.
 */
const sortTopologically = (dependencyList) => {
    const depGraph = createDependencyGraph(dependencyList);
    // init sorted list
    const sortedList = [];
    // we will use visiting nodes to track the list of nodes
    // we are currently exploring, which allows us to detect cycles
    const visitingNodes = new Set();
    // we will use visitedNodes to track nodes that we have successfully
    // explored without cycle detection
    const visitedNodes = new Set();
    // we will use cycles to house any nodes identified in a cycle
    const cycles = new Set();
    // dfs helper method
    const dfs = (node) => {
        // add visiting node
        visitingNodes.add(node);
        // get dependencies for the specific node
        const deps = depGraph[node];
        // deeply explore each dependency
        (0, remeda_1.forEach)(deps, (dep) => {
            if (visitingNodes.has(dep)) {
                // cycle has been detected!
                // let's track it and escape out of the cycle
                cycles.add(dep);
                return;
            }
            // continue to explore
            dfs(dep);
        });
        // we have deeply (and successfully) explored this node
        // we can remove it from visiting nodes
        visitingNodes.delete(node);
        // let's add to visited nodes and push to sorted list
        // if it hasn't already been added
        if (!visitedNodes.has(node)) {
            visitedNodes.add(node);
            sortedList.push(node);
        }
    };
    // explore all the nodes of the dependency graph
    const nodes = (0, remeda_1.keys)(depGraph);
    (0, remeda_1.forEach)(nodes, (node) => {
        dfs(node);
    });
    return cycles.size
        ? { cycles: Array.from(cycles), sortedList: undefined }
        : { cycles: [], sortedList };
};
exports.sortTopologically = sortTopologically;
//# sourceMappingURL=topologicalSort.js.map